import React from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { InfoTooltip } from './Tooltips/InfoTooltip';

const AutoComplete = ({
  tooltip,
  tooltipType,
  tooltipLabel,
  label,
  onChange,
  open,
  onOpen,
  onClose,
  onInputChange,
  options,
  placeholder,
  disabled,
  error,
  ...rest
}) => (
  <div className="mb-2">
    {label && (
      <label
        className={`uppercase tracking-wide ${
          disabled ? 'text-gray-400' : 'text-gray-600'
        } text-xs font-semibold mb-2`}
      >
        <div className="flex flex-row gap-2 items-center">
          {label}
          {tooltip && <InfoTooltip placement={tooltip} data={tooltipType} label={tooltipLabel} />}
        </div>
      </label>
    )}
    <div
      className={`relative w-full bg-gray-200 text-gray-800 rounded px-4 leading-tight focus:outline-none
      border ${error ? 'border-red-400' : 'border-gray-200'}`}
    >
      <Autocomplete
        id="asynchronous-demo"
        options={options}
        disabled={disabled}
        open={open}
        onOpen={onOpen}
        onClose={onClose}
        onChange={(event, valueZ) => onChange(valueZ)}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            margin="normal"
            inputProps={{
              ...params.inputProps,
              spellCheck: true,
              autoCorrect: 'on',
              autoCapitalize: 'sentences',
            }}
          />
        )}
        {...rest}
      />
    </div>
  </div>
);

AutoComplete.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string])).isRequired,
  placeholder: PropTypes.string.isRequired,
  label: PropTypes.string,
};

AutoComplete.defaultProps = {
  label: null,
};

export default AutoComplete;
